module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00004.2f9931ff.jpg",
  width: 4752,
  height: 3168,
  bytes: 605522,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00004.2f9931ff.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00004.jpg
// module id = 237
// module chunks = 0